import { Region } from '@lemon8/web-app-shared/i18n';

export enum FileTypeMap {
  materialFiles = 1,
  proofFiles = 2,
  certificateFiles = 3,
}

export enum ReportType {
  COPYRIGHT = 1,
  TRADEMARK = 2,
}

export interface Files {
  fileName: string;
  fileUrl: string;
  type: FileTypeMap;
  tosURI: string;
}

export interface InfringementResponse {
  isInApp: boolean;
  idcRegion: string;
  reportType: ReportType;
  reporterDto: {
    address: string;
    email: string;
    ownerName: string;
    phone: string;
    relationship: number;
    reporterRegion: Region;
    signature: string;
    legalOwner: string;
  };
  copyrightDto?: {
    contentType: number;
    contentURL: string;
    proofFiles: Files[];
    typeDescription: string;
    materialFiles: Files[];
  };
  trademarkDto?: {
    certificateFiles: Files[];
    contentURL: string;
    goodsAndClass: string;
    infringementDescription: string;
    materialFiles: Files[];
    proofFiles: Files[];
    registrationJurisdiction: string;
    registrationNumber: string;
    recordUrl: string;
  };
  extra?: {
    cfGoods: string;
  };
}
